import React from 'react';
import { CourseCard } from './CourseCard';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function CourseGrid() {
  return <section id="kurse" className="py-24 bg-white" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <ScrollReveal variant="up" data-id="element-118">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-119">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-120">
              Das Curriculum im Überblick
            </span>
            <h2 className="text-2xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-121">
              Intensiv Curriculum Zahnmedizin
            </h2>
            <p className="text-base sm:text-lg text-slate-500 font-medium" data-id="element-122">
              Kursreihe von A - Z. Praxisnahe Weiterbildung & anerkannte
              Fortbildungspunkte für Zahnärzte.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-16" data-id="element-123">
          <ScrollReveal variant="up" delay={100} className="h-full" data-id="element-124">
            <CourseCard title="A-Kurs White Aesthetics" subtitle="Ästhetische Zahnheilkunde" description="Moderne Fortbildung für weiße Ästhetik und perfekte Zahnrestaurationen." points={15} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/whiteaestetics.jpg" slug="white-aesthetics" data-id="element-125" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} className="h-full" data-id="element-126">
            <CourseCard title="B-Kurs Red Aesthetics" subtitle="Weichgewebsmanagement" description="Fortbildung für Zahnärzte zur Optimierung des Zahnfleischs und der roten Ästhetik." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursweichgewebe.jpg" slug="red-aesthetics" data-id="element-127" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} className="h-full" data-id="element-128">
            <CourseCard title="C-Kurs Funktion" subtitle="Funktionelle Zahnmedizin" description="Professionelle Fortbildung für okklusale Funktion und Kiefergelenkdiagnostik." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursfunktionellezahnmedizin.jpg" slug="funktionsanalyse-therapie" data-id="element-129" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={100} className="h-full" data-id="element-130">
            <CourseCard title="D-Kurs Champions League" subtitle="Praxismanagement & Strategie" description="Erfolgreiches Praxisteam & Leadership für Zahnärzte." points={15} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kurspraxismanagement.jpeg" slug="champions-league" data-id="element-131" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} className="h-full" data-id="element-132">
            <CourseCard title="Female Boss" subtitle="Karriere-Workshop für Zahnärztinnen" description="Selbstständigkeit & Führungskompetenz gezielt stärken." points={7} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursfemaleboss.jpg" slug="female-boss" data-id="element-133" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} className="h-full" data-id="element-134">
            <CourseCard title="Alignertherapie" subtitle="Unsichtbare Zahnspange" description="Alignertherapie meistern und Umsätze steigern." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursalignertherapie.jpg" slug="alignertherapie" data-id="element-135" />
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={400} data-id="element-136">
          <div className="text-center" data-id="element-137">
            <Link to="/kontakt" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-lg" data-id="element-138">
              Jetzt Kursplan sichern
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-139" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}